import { ISearchIOAggregationCount } from '@unified-commerce/gpc-vue-storefront-search';

const isBrandCategory =
  (brandCategoriesPrefixHandle: string) =>
  ([handle]: [string, number]) =>
    handle.startsWith(brandCategoriesPrefixHandle);

const sortByProductCountDescending = (
  [, productACount]: [string, number],
  [, productBCount]: [string, number],
) => (productBCount ?? 0) - (productACount ?? 0);

const stripBrandPrefixHandle =
  (brandCategoriesPrefixHandle: string) =>
  ([brandCategoryHandle]: [string, number]) =>
    brandCategoryHandle.replace(`${brandCategoriesPrefixHandle}-`, '');

export const getSortedBrandCategoryHandlesByProductCount = (
  categories: ISearchIOAggregationCount,
  numOfBrands: number,
  brandCategoriesPrefixHandle: string,
) =>
  Object.entries(categories)
    .filter(isBrandCategory(brandCategoriesPrefixHandle))
    .sort(sortByProductCountDescending)
    .slice(0, numOfBrands)
    .map(stripBrandPrefixHandle(brandCategoriesPrefixHandle));
